<template>
  <div class="all-order">
    <div class="content-wrapper">
      <router-link to="/console/homework/create">
        <button class="new-btn">创建作业></button>
      </router-link>
      <div class="workitem-wrapper">
        <template v-if="!isEmpty(classList)">
          <class-item :isComplete="true" :id="id" :classinfo="item" v-for="(item,index) in classList" :key="index"></class-item>
        </template>
        <el-pagination
          v-if="totalPage>10"
          background
          layout="prev, pager, next"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          :page-size="10"
          :total="totalPage">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import classItem from '../component/classitem'

  export default {
    data() {
      return {
        id: (() => loadLocal('id', false))(),
        schoolNow: (() => loadLocal('schoolNow', false))(),
        currentPage: 1,
        totalPage: 1,
        classList: [],
      }
    },
    methods: {
      isEmpty(obj) {
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      handleCurrentChange(val) {
        this.QueryClassWork(val);
        this.$forceUpdate();
      },
      QueryClassWork(pageno) {
        let params = {
          c: 'HomeWork',
          a: 'QueryHomeWork',
          id: this.id,                //sessionid
          rid: this.schoolNow.rid,
          isstudent:0,
          iscomplete:1,
          pageno: pageno,
          pagesize: 10,
        };
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: params
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.classList = response.list;
            this.totalPage = Number(response.recordcount);
            this.$forceUpdate();
          }
        }).catch((err) => {
        });
      }
    },
    created() {
      this.QueryClassWork(1);
    },
    components:{
      classItem
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .all-order
    width: 100%
    height: 100%
    background: #f2f2f2
    font-size: 0
    overflow auto
    .content-wrapper
      margin: 111px 20px 20px 180px
      width: 1166px
      .new-btn {
        display: inline-block
        width: 114px
        height: 40px
        line-height: 40px
        font-size: 16px
        color: #ffffff
        background: #3399ff
        border-radius: 4px
      }
      .workitem-wrapper {
        margin-top: 20px
      }
</style>



// WEBPACK FOOTER //
// src/page/teacherhomework/done/done.vue